import { ArrowBack as ArrowBackIcon } from "@mui/icons-material";
import { AppBar, Dialog, IconButton, Toolbar, Typography } from "@mui/material";
import { RenderFilePreview } from "components/filePreview/RenderFilePreview";
import { FC, useCallback } from "react";
import { useIntl } from "react-intl";
import { useAppDispatch, useAppSelector } from "store";
import { closeFilePreview } from "store/slices/dialogs/filePreview.store";

export const FilePreviewDialog: FC = () => {
  const intl = useIntl();
  const { open, file } = useAppSelector((s) => s.filePreview);
  const dispatch = useAppDispatch();

  const onClose = useCallback(() => {
    dispatch(closeFilePreview());
  }, [dispatch]);

  return (
    <Dialog fullScreen open={open} onClose={onClose} data-testid="FilePreviewDialog">
      <AppBar position="fixed">
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={onClose}
            aria-label={intl.formatMessage({ id: "general.back" })}
            size="large"
            data-testid="FilePreviewDialog-CloseButton"
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h6" marginLeft="16px" flex={1}>
            {file?.name}
          </Typography>
        </Toolbar>
      </AppBar>
      <Toolbar />
      <RenderFilePreview file={file} />
    </Dialog>
  );
};
